import { z } from "zod";

// Mirrors apps/project/serializers/project.py (AdminProjectSerializer) as
// used by the admin-facing ProjectFormSheet, which always includes an
// `owner` field ("owner is writable and must be provided in the request").
// `name` mirrors Project.name (CharField max_length=255); `description` is
// blank=True/null=True on the model, so it's optional; `status` defaults to
// "draft" server-side; `start_date`/`due_date` are nullable.
// `member_ids` is client-side only -- applied via add-member/remove-member
// calls after create/update, not part of the model's own writable fields.
export const PROJECT_STATUS_OPTIONS = [
  "draft",
  "active",
  "on_hold",
  "completed",
  "cancelled",
] as const;

export const projectSchema = z.object({
  owner: z.number({ error: "Owner is required" }),
  name: z.string().trim().min(1, "Name is required").max(255, "Max 255 characters"),
  description: z.string().optional(),
  status: z.enum(PROJECT_STATUS_OPTIONS).optional(),
  start_date: z.string().nullable().optional(),
  due_date: z.string().nullable().optional(),
  member_ids: z.array(z.number()).optional(),
});

export type ProjectFormValues = z.infer<typeof projectSchema>;

export const PROJECT_FIELDS = [
  "owner",
  "name",
  "description",
  "status",
  "start_date",
  "due_date",
] as const;
